import React, { useMemo } from 'react';
import {
  CheckboxContainer,
  CheckboxWrapper,
  Container,
  HiddenCheckbox,
  StyledCheckbox,
} from './styles';

import Icon from '@components/Icon';
import { useTheme } from 'styled-components';

export interface CheckboxProps {
  label?: JSX.Element;
  className?: string;
  checked: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  disabled?: boolean;
  type: 'square' | 'round';
  size?: string;
  spacing?: string;
  backgroundColor?: string;
  border?: string;
  focusBorder?: string;
  color?: string;
  alignItems?: string;
  borderRadius?: string;
  iconName?: string;
  padding?: string;
}

const Checkbox = ({
  label,
  className,
  checked,
  onChange,
  disabled,
  type,
  size = '2rem',
  spacing = '1rem',
  backgroundColor,
  border,
  focusBorder,
  color,
  alignItems,
  borderRadius,
  iconName,
  padding,
}: CheckboxProps) => {
  const theme = useTheme();

  const iconSize = useMemo(() => Number(size.split('rem')[0]) * 11, [size]);
  const iconColor = useMemo(() => {
    if (color) return color;
    else {
      if (type === 'round') {
        return theme.color.white;
      } else return theme.color.greyDark;
    }
  }, [color, theme.color.greyDark, theme.color.white, type]);

  return (
    <CheckboxWrapper $gap={spacing} $alignItems={alignItems} $padding={padding}>
      <Container>
        <CheckboxContainer className={className}>
          <HiddenCheckbox
            disabled={disabled}
            checked={checked}
            onChange={onChange}
          />
          <StyledCheckbox
            $checked={checked}
            $type={type}
            $size={size}
            $backgroundColor={backgroundColor}
            $border={border}
            $borderColorCheckedSquare={theme.color.primary}
            $borderRadius={borderRadius}
            $focusBorder={focusBorder}
          >
            {checked && type === 'square' && (
              <Icon
                size={iconSize ?? 30}
                name={iconName ?? 'close'}
                indentLess
                color={iconColor}
              />
            )}
          </StyledCheckbox>
        </CheckboxContainer>
      </Container>
      {label}
    </CheckboxWrapper>
  );
};

export default Checkbox;
